module.exports = __webpack_public_path__ + "static/media/cancel.e503e0e7.svg";